<app-dialog
  #dialog
  [key]="'sale-operation'"
  [action]="'sale-operation'"
  [headerTheme]="'simple'"
  [title]="(tk.Management.NdfSettleOperation | t) || ''">
  <div class="container-fluid">
    <div class="row">
      <div class="operation-summary-box" *ngIf="currentOperationToSaleSummary as op">
        <div class="operation-summary-title">
          {{ op.sequentialId || op.id }}
        </div>
        <div class="operation-summary-meta">
          <span>{{ getOperationStatusLabel(op.operationStatus) }}</span>
          <span>•</span>
          <span>{{ getFinancialStatusLabel(op.financialStatus) }}</span>
          <span>•</span>
          <span>{{ getCompositionLabel(op.composition) }}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="dialog-sale-operation">
        <div class="dialog-sale-operation__header">
          <div class="dialog-sale-operation__header__title">
            <h3>{{ tk.Management.NdfSettlementInformation | t }}</h3>
          </div>
        </div>
        <div class="dialog-sale-operation__content">
          <div class="liquidation-loading-overlay" *ngIf="isModalLoading">
            <app-cog-loading-spinner [size]="48"></app-cog-loading-spinner>
          </div>
          <form
            *ngIf="currentOperationToSale"
            [formGroup]="currentOperationSaleForm"
            appAutoFormGroup>
            <div class="row">
              <div class="col-12 col-sm-6 col-md-3 mb-3">
                <div class="dialog-sale-operation__content__item">
                  <h3>{{ tk.Management.NdfSettlementDate | t }}</h3>
                  <app-calendar
                    [placeholder]="(tk.General.Insert | t) || ''"
                    [maxDate]="currentDate"
                    [date]="
                      currentOperationSaleForm.get(currentOperationSaleProps.settlementDate)
                        ?.value || ''
                    "
                    [disabled]="liquidationType === 'full'"
                    [isHighlight]="true"
                    [showTime]="false"
                    [inputId]="'settlementDate'"
                    [theme]="'clean'"
                    (sendCalendarValue)="onCalendarValue($event)" />
                  <small
                    class="text-danger mt-2 d-block"
                    *ngIf="
                      currentOperationSaleForm.get(currentOperationSaleProps.settlementDate)
                        ?.touched &&
                      currentOperationSaleForm.get(currentOperationSaleProps.settlementDate)
                        ?.invalid
                    ">
                    Informe a data da liquidação.
                  </small>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-3 mb-3">
                <div class="dialog-sale-operation__content__item">
                  <h3>{{ tk.Management.NdfNotionalSettlement | t }}</h3>
                  <div class="mt-4">
                    <app-input
                      [placeholder]="(tk.General.Insert | t) || ''"
                      [id]="'settlementNotional'"
                      [theme]="'clean'"
                      [isHighlight]="true"
                      [minFractionDigits]="2"
                      [max]="currentOperationToSaleSummary?.notionalAmount || 0"
                      [type]="'number'"
                      [readonly]="
                        liquidationType === 'full' || liquidationType === 'partial-before'
                      "
                      [value]="
                        currentOperationSaleForm.get(currentOperationSaleProps.settlementNotional)
                          ?.value
                      "
                      [controlName]="'settlementNotional'"
                      (sendInputValue)="onInputNumber($event, 'settlementNotional')">
                    </app-input>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-3 mb-3">
                <div class="dialog-sale-operation__content__item">
                  <h3>{{ tk.Management.NdfSettlementSpot | t }}</h3>
                  <div class="mt-4">
                    <app-input
                      [placeholder]="(tk.General.Insert | t) || ''"
                      [id]="'settlementSpot'"
                      [theme]="'clean'"
                      [type]="'number'"
                      [readonly]="liquidationType === 'full'"
                      [min]="0.1"
                      [isHighlight]="true"
                      [minFractionDigits]="4"
                      [value]="
                        currentOperationSaleForm.get(currentOperationSaleProps.settlementSpot)
                          ?.value
                      "
                      [controlName]="'settlementSpot'"
                      (sendInputValue)="onInputNumber($event, 'settlementSpot')">
                    </app-input>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-3 mb-3">
                <div class="dialog-sale-operation__content__item">
                  <h3>{{ tk.Management.NdfSettlementFee | t }}</h3>
                  <div class="mt-4">
                    <app-input
                      [placeholder]="(tk.General.Insert | t) || ''"
                      [id]="'settlementRate'"
                      [theme]="'clean'"
                      [type]="'number'"
                      [readonly]="liquidationType === 'full'"
                      [min]="0.1"
                      [isHighlight]="true"
                      [minFractionDigits]="4"
                      [value]="
                        currentOperationSaleForm.get(currentOperationSaleProps.settlementRate)
                          ?.value
                      "
                      [controlName]="'settlementRate'"
                      (sendInputValue)="onInputNumber($event, 'settlementRate')">
                    </app-input>
                    <small
                      class="text-danger mt-2 d-block"
                      *ngIf="
                        currentOperationSaleForm.get(currentOperationSaleProps.settlementRate)
                          ?.touched &&
                        currentOperationSaleForm.get(currentOperationSaleProps.settlementRate)
                          ?.invalid
                      ">
                      Informe a taxa de liquidação.
                    </small>
                    <div class="text-center">
                      PTAX do dia {{ currentPtaxQuotationDate | vaultDate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-2">
                <app-checkbox
                  [checkbox]="manualAdjustmentCheckbox"
                  (sendCheckedChange)="onManualAdjustmentToggle($event)">
                </app-checkbox>
                <small class="d-block text-muted">
                  Marque para registrar o que o banco efetivamente liquidou. O Ajuste Líquido
                  continua sendo calculado como bruto − IRRF − IR a pagar.
                </small>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 col-md-3 mb-3">
                <div class="dialog-sale-operation__content__item">
                  <h3 class="mb-3">
                    {{ tk.Management.NdfGrossAdjustment | t }}
                  </h3>
                  <app-input
                    *ngIf="isManualAdjustment; else totalAmountReadonly"
                    [placeholder]="(tk.General.Insert | t) || ''"
                    [id]="'manualTotalAmount'"
                    [theme]="'clean'"
                    [type]="'number'"
                    [isHighlight]="true"
                    [minFractionDigits]="2"
                    [value]="
                      currentOperationSaleForm.get(currentOperationSaleProps.totalAmount)?.value
                    "
                    [controlName]="'totalAmount'"
                    (sendInputValue)="onManualValueInput($event, 'totalAmount')">
                  </app-input>
                  <ng-template #totalAmountReadonly>
                    <h3 class="item-value">
                      {{
                        currentOperationSaleForm.get(currentOperationSaleProps.totalAmount)
                          ?.value || 0 | number: '1.2-2'
                      }}
                    </h3>
                  </ng-template>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-3 mb-3">
                <div class="dialog-sale-operation__content__item">
                  <h3 class="mb-3">{{ tk.Management.NdfIRRF | t }}</h3>
                  <app-input
                    *ngIf="isManualAdjustment; else withholdingTaxReadonly"
                    [placeholder]="(tk.General.Insert | t) || ''"
                    [id]="'manualWithholdingTax'"
                    [theme]="'clean'"
                    [type]="'number'"
                    [isHighlight]="true"
                    [minFractionDigits]="2"
                    [value]="
                      currentOperationSaleForm.get(currentOperationSaleProps.withholdingTax)?.value
                    "
                    [controlName]="'withholdingTax'"
                    (sendInputValue)="onManualValueInput($event, 'withholdingTax')">
                  </app-input>
                  <ng-template #withholdingTaxReadonly>
                    <h3 class="item-value">
                      {{
                        currentOperationSaleForm.get(currentOperationSaleProps.withholdingTax)
                          ?.value || 0 | number: '1.2-2'
                      }}
                    </h3>
                  </ng-template>
                </div>
              </div>
              <div
                class="col-12 col-sm-6 col-md-3 mb-3"
                *ngIf="currentOperationToSaleSummary?.operationStrategyType !== 'SWAP'">
                <div class="dialog-sale-operation__content__item">
                  <h3 class="mb-3">{{ tk.Management.NdfIRToPay | t }}</h3>
                  <app-input
                    *ngIf="isManualAdjustment; else incomeTaxPayableReadonly"
                    [placeholder]="(tk.General.Insert | t) || ''"
                    [id]="'manualIncomeTaxPayable'"
                    [theme]="'clean'"
                    [type]="'number'"
                    [isHighlight]="true"
                    [minFractionDigits]="2"
                    [value]="
                      currentOperationSaleForm.get(currentOperationSaleProps.incomeTaxPayable)
                        ?.value
                    "
                    [controlName]="'incomeTaxPayable'"
                    (sendInputValue)="onManualValueInput($event, 'incomeTaxPayable')">
                  </app-input>
                  <ng-template #incomeTaxPayableReadonly>
                    <h3 class="item-value">
                      {{
                        currentOperationSaleForm.get(currentOperationSaleProps.incomeTaxPayable)
                          ?.value || 0 | number: '1.2-2'
                      }}
                    </h3>
                  </ng-template>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-3 mb-3">
                <div class="dialog-sale-operation__content__item">
                  <h3 class="mb-3">{{ tk.Management.NdfNetAdjustment | t }}</h3>
                  <h3 class="item-value">
                    {{
                      currentOperationSaleForm.get(currentOperationSaleProps.netAmount)?.value || 0
                        | number: '1.2-2'
                    }}
                  </h3>
                </div>
              </div>
            </div>
          </form>
          <div
            class="text-warning-emphasis mt-2 text-center"
            *ngIf="isSettlementRateMissing && !isModalLoading">
            {{ missingSettlementRateMessage }}
          </div>
          <div class="text-danger mt-2 text-center" *ngIf="simulationFailed">
            {{
              simulationErrorMessage
                ? 'Não foi possível calcular os valores da liquidação: ' +
                  simulationErrorMessage +
                  '.'
                : 'Não foi possível calcular os valores da liquidação. Ajuste os dados e tente novamente.'
            }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #footer>
    <div class="d-flex justify-content-end gap-2">
      <app-button
        [id]="'cancel-liquidation'"
        [icon]="'pi pi-times'"
        [type]="'button'"
        [theme]="'white'"
        [label]="tk.General.Cancel | t"
        (click)="close()">
      </app-button>
      <app-button
        *ngIf="showSaveReversalButton"
        [id]="'save-reversal'"
        [icon]="'save'"
        [type]="'button'"
        [theme]="'dashed'"
        [disabled]="isSubmitBlocked"
        [title]="(tk.Management.NdfAddSettlementReversedTitle | t) || ''"
        [label]="tk.Management.NdfAddSettlementReversed | t"
        (click)="onSaveReversalClick()">
      </app-button>
      <app-button
        [id]="'liquidate-operation'"
        [icon]="'pi pi-check'"
        [type]="'button'"
        [theme]="'default'"
        [disabled]="isSubmitBlocked"
        [title]="(tk.Management.NdfSettleOperation | t) || ''"
        [label]="(tk.Management.NdfSettleOperation | t) || ''"
        (click)="onLiquidateClick()">
      </app-button>
    </div>
  </ng-template>
</app-dialog>
